import React from 'react';
import { Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { object } from 'prop-types';

import { withAuth, authProptypes } from '../auth';
import { Wrappers, PrimaryButton, ErrorCard } from '../components';
import { withPageViewTracking } from '../analytics';

import { FLEX_CENTERED, FOOTER_FULL } from '../constants';

export const LoginComponent = ({ authActions, authUser }) => {
  // display error message for blocked user
  if (authUser && authUser.isBlocked) {
    return (
      <Wrappers.Layout type={FLEX_CENTERED} footerType={FOOTER_FULL}>
        <ErrorCard
          title={<FormattedMessage id="title.issue" />}
          description={
            <FormattedMessage
              id="description.issue"
              values={{
                break: <br />,
                email: (
                  <a href="mailto:agidealersupport@aggrowth.com">
                    agidealersupport@aggrowth.com
                  </a>
                )
              }}
            />
          }
          showLink={false}
          alignLeft={true}
        />
      </Wrappers.Layout>
    );
  }

  return (
    <Wrappers.Layout type={FLEX_CENTERED} footerType={FOOTER_FULL}>
      <Wrappers.SegmentFull>
        <Header as="h1" style={{ marginBottom: '16px' }}>
          <FormattedMessage
            id="title.login"
            description="Login page title"
            defaultMessage="Login"
          />
        </Header>
        <p style={{ marginBottom: '24px' }}>
          <FormattedMessage
            id="description.login"
            description="Login page description"
            values={{
              url: (
                <a href="https://www.aggrowth.com/dealersupportsignup">
                  aggrowth.com/dealersupportsignup
                </a>
              ),
              br: <br />
            }}
            defaultMessage="If you do not have an AGI Dealer Support login yet, go to {url} to submit an application.{br}If approved, we will get back to you in approximately 48 hours with an email confirming your access to the AGI Dealer Support website."
          />
        </p>
        <PrimaryButton onClick={authActions.signIn} qa="login-submit-button">
          <FormattedMessage
            id="cta.login"
            description="Login CTA"
            defaultMessage="Login"
          />
        </PrimaryButton>
      </Wrappers.SegmentFull>
    </Wrappers.Layout>
  );
};

LoginComponent.propTypes = {
  authActions: authProptypes.actions,
  authUser: object
};

const Login = withPageViewTracking()(withAuth(LoginComponent));

export default Login;
